<template>
  <v-row :class="bgClass">
    <v-col
      :cols="$vuetify.breakpoint.smAndDown ?12 :10"
      :offset="$vuetify.breakpoint.smAndDown ? 0 : 1"
      :class="$vuetify.breakpoint.smAndDown ? 'd-flex justify-start align-start' :'d-flex justify-center align-center'"
    >
      <v-card :class="$vuetify.breakpoint.smAndDown ? 'mx-3':'py-6'" style="background-color: #f7f7f7" width="100%">
        <v-row>
          <v-col cols="12">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="6" class="pr-6">
                  <v-text-field
                    outlined
                    class="mb-5"
                    label="PRIMER NOMBRE*"
                    placeholder="Juan"
                    v-model="information.name_first"
                    type="text"
                    id="name_first"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    class="mb-5"
                    label="SEGUNDO NOMBRE"
                    placeholder="Luis"
                    v-model="information.name_second"
                    type="text"
                    id="name_second"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    class="mb-5"
                    label="APELLIDO PATERNO*"
                    placeholder="López"
                    v-model="information.last_name"
                    type="text"
                    id="lastname"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    class="mb-5"
                    label="APELLIDO MATERNO*"
                    placeholder="Garcia"
                    v-model="information.mother_last_name"
                    type="text"
                    id="lastname"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    class="mb-5"
                    label="CORREO ELECTRÓNICO*"
                    v-model="information.email"
                    placeholder="correo@ejemplo.com"
                    type="email"
                    id="email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="pl-6">
                  <v-text-field
                    outlined
                    class="mb-5"
                    label="NÚMERO TELEFÓNICO*"
                    v-model="information.phone"
                    v-mask="'##########'"
                    type="phone"
                    id="phone"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    class="mb-5"
                    label="LOCALIDAD*"
                    placeholder="Tepic"
                    v-model="information.localidad"
                    type="phone"
                    id="phone"
                  ></v-text-field>
                  <v-select
                    outlined
                    :items="states"
                    label="ESTADO*"
                    v-model="information.state"
                    item-value="key"
                  ></v-select>
                  <v-text-field
                    outlined
                    v-show="information.state == 'OTRO...'"
                    label="Otro estado"
                    v-model="information.other_state"
                    type="text"
                    id="other_state"
                  ></v-text-field>
                  <v-select
                    :items="lic"
                    label="LICENCIATURA DE INTERÉS*"
                    outlined
                    item-text="text"
                    item-value="key"
                    v-model="information.lic"
                  ></v-select>
                  <v-textarea
                    outlined
                    label="MENSAJE*"
                    rows="6"
                    counter="200"
                    no-resize
                    v-model="information.message"
                    id="lastname"
                  ></v-textarea>
                </v-col>
                <v-col class="py-0" cols="12">
                  <vue-recaptcha
                    @expired="successRecaptcha = false"
                    @verify="reCAPTCHAcallback()"
                    sitekey="6Lc8XKkbAAAAAEl5syMFnnddk1gllGQIxJ8RE4vx"
                    :loadRecaptchaScript="true"
                  ></vue-recaptcha>
                </v-col>                
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-2">
              <v-layout
                :row="$vuetify.breakpoint.mdAndUp"
                :column="$vuetify.breakpoint.smAndDown"
                :reverse="$vuetify.breakpoint.smAndDown"
                class="mx-2"
              >
                <div
                  class="flex-grow-1"
                  v-if="$vuetify.breakpoint.mdAndUp"
                ></div>
                <v-btn
                  rounded
                  :x-large="$vuetify.breakpoint.lgAndUp"
                  text
                  class="px-5"
                  @click="clearFields()"
                  >Cancelar</v-btn
                >
                <v-btn
                  rounded
                  :x-large="$vuetify.breakpoint.lgAndUp"
                  color="primary"
                  class="px-5"
                  @click="submit()"
                  :disabled="isLoading || !successRecaptcha"
                  >Enviar formulario</v-btn
                >
              </v-layout>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn color="white" dark text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import { mask } from "vue-the-mask";
import axios from "axios";
import moment from "moment";

export default {
  directives: {
    mask,
  },
  props: ["bgClass", "originProcedence"],
  data: () => ({
    snackbar: false,
    snackbarColor: "info",
    snackbarText: "",
    fromlink: null,
    isLoading: false,
    publicPath: process.env.BASE_URL,
    campusSelected: "",
    successRecaptcha: false,
    offsetTop: 0,
    lic: [
      { key: "4EBD213C-B93E-48D1-988C-D54F959BC211", text: "Lic. Admin. de empresas" },
      { key: "27676024-2122-40C5-A836-D4009309D0AF", text: "Lic. Ciencias de la educación" },
      { key: "52CE8D18-E9B9-4310-BC5D-8BB4872AFE4A", text: "Lic. Contaduría" },
      { key: "C07B1B9D-CF73-42D7-BF6E-98CD28705008", text: "Lic. Comercio internacional" },
      { key: "C17F5334-F0F1-4693-93F6-1E116074E812", text: "Lic. Derecho" },
    ],
    states: [
      { key: "AGS", text: "AGUASCALIENTES" },
      { key: "BC", text: "BAJA CALIFORNIA" },
      { key: "BCS", text: "BAJA CALIFORNIA SUR" },
      { key: "CHIH", text: "CHIHUAHUA" },
      { key: "CHIS", text: "CHIAPAS" },
      { key: "CAMP", text: "CAMPECHE" },
      { key: "DF", text: "CIUDAD DE MEXICO" },
      { key: "COAH", text: "COAHUILA" },
      { key: "COL", text: "COLIMA" },
      { key: "DGO", text: "DURANGO" },
      { key: "GRO", text: "GUERRERO" },
      { key: "GTO", text: "GUANAJUATO" },
      { key: "HGO", text: "HIDALGO" },
      { key: "JAL", text: "JALISCO" },
      { key: "MICH", text: "MICHOACAN" },
      { key: "MEX", text: "ESTADO DE MEXICO" },
      { key: "MOR", text: "MORELOS" },
      { key: "NAY", text: "NAYARIT" },
      { key: "NL", text: "NUEVO LEON" },
      { key: "OAX", text: "OAXACA" },
      { key: "PUE", text: "PUEBLA" },
      { key: "QROO", text: "QUINTANA ROO" },
      { key: "QRO", text: "QUERETARO" },
      { key: "SIN", text: "SINALOA" },
      { key: "SNL", text: "SAN LUIS POTOSI" },
      { key: "SON", text: "SONORA" },
      { key: "TAB", text: "TABASCO" },
      { key: "TLX", text: "TLAXCALA" },
      { key: "TAMS", text: "TAMAULIPAS" },
      { key: "VER", text: "VERACRUZ" },
      { key: "YUC", text: "YUCATAN" },
      { key: "ZAC", text: "ZACATECAS" },
    ],
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
      lic: "",
      horarios: "",
      localidad: "",
      message:
        "Me interesa toda la información disponible sobre este tema",
      licenciatura: false,
      posgrado: false,
      otros: false,
      escolaridad: "",
      school: "",
      state: "",
      other_state: "",
      way: "",
    },
  }),
  methods: {
    reCAPTCHAcallback() {
      this.successRecaptcha = true;
    },    
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone = /^[0-9]{10}$/;
      return phone.test(number);
    },
    validateFields() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.lic != "" &&
        this.information.localidad != "" &&
        this.information.state != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText =
          "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        this.snackbarColor = "dark";
      }
    },
    submit() {
      this.validateFields();
      if (this.valid) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      this.information.escolaridad = this.originProcedence;
      if (this.valid && this.emailValid && this.phoneValid) {
        this.sendInfoData();
      }
    },
    sendInfoData() {
      let self = this;
      self.isLoading = true;
      let name =  this.information.name_first + (this.information.name_second == '' ? '' : ' '+this.information.name_second)
      let last_name = this.information.last_name + (this.information.mother_last_name == '' ? '' : ' '+this.information.mother_last_name)
      let now = moment();

      axios
        .post("https://api.salesup.com/integraciones/P25AP87381638-F4F9-4431-96D3-8F1B402E859E", {
          nombre: name,
          apellidos: last_name,
          correo: this.information.email,
          movil: this.information.phone,
          cp22: this.information.lic,
          idestado: this.information.state,
          comentarios: this.information.message,
          cuidad: this.information.localidad,
          // ----- AD'S
          url: "https://uvaenlinea.uva.edu.mx",
          referrer: "https://www.google.com/",
          browser: "Chrome 105",
          esMovil: false,
          gclid: "",
          fbclid: "",
          utm_source: "https://uvaenlinea.uva.edu.mx/inscripciones",
          utm_medium: "Organico",
          utm_campaign: "",
          utm_term: "",
          utm_date: now.toISOString(),
          utm_content: ""
      })
        .then(response => {
          if (response.data[0].msg == "Ok") {
            self.snackbarText =
              "Información enviada, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.clearFields();
          } else {
            self.snackbarText =
              "Ocurrió un error al enviar tu información, intentalo mas tarde";
            self.snackbarColor = "error";
            self.snackbar = true;
            self.clearFields();
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    clearFields() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        carrer: "",
        horarios: "",
        localidad: "",
        message:
          "Me interesa toda la información disponible sobre este tema",
        licenciatura: false,
        posgrado: false,
        otros: false,
        escolaridad: "",
        school: "",
        way: "",
      };
    },
  },
};
</script>